import React from "react";
import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
import { INDICATOR_DISPLAY_THRESHOLD } from 'jitsi/connection-indicator/components/AbstractConnectionIndicator';
import { ConnectionIndicatorContent, _mapDispatchToProps, _mapStateToProps } from "jitsi/connection-indicator/components/web/ConnectionIndicatorContent";
import ConnectionStatsTable from 'jitsi/connection-stats/components/ConnectionStatsTable';
const QUALITY_TO_WIDTH = [
    // Full (3 bars)
    {
        colorClass: 'status-high',
        percent: INDICATOR_DISPLAY_THRESHOLD,
        tip: 'connectionindicator.quality.good',
        width: '100%'
    },
    // 2 bars
    {
        colorClass: 'status-med',
        percent: 10,
        tip: 'connectionindicator.quality.nonoptimal',
        width: '66%'
    },
    // 1 bar
    {
        colorClass: 'status-low',
        percent: 0,
        tip: 'connectionindicator.quality.poor',
        width: '33%'
    }
    // Note: we never show 0 bars as long as there is a connection.
];
class IISightConnectionIndicatorContent extends ConnectionIndicatorContent {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { bandwidth, bitrate, bridgeCount, codec, framerate, maxEnabledResolution, packetLoss, resolution, serverRegion, transport } = this.state.stats;
        return (React.createElement(ConnectionStatsTable, { audioSsrc: this.props._audioSsrc, bandwidth: bandwidth, bitrate: bitrate, bridgeCount: bridgeCount, codec: codec, connectionSummary: this._getConnectionStatus(), disableShowMoreStats: this.props._disableShowMoreStats, e2eeVerified: this.props._isE2EEVerified, enableAssumedBandwidth: this.props._enableAssumedBandwidth, enableSaveLogs: this.props._enableSaveLogs, framerate: framerate, isLocalVideo: this.props._isLocalVideo, isNarrowLayout: this.props._isNarrowLayout, isVirtualScreenshareParticipant: this.props._isVirtualScreenshareParticipant, maxEnabledResolution: maxEnabledResolution, onOpenBandwidthDialog: this.props._onOpenBandwidthDialog, onSaveLogs: this.props._onSaveLogs, onShowMore: this._onToggleShowMore, packetLoss: packetLoss, participantId: this.props.participantId, region: this.props._region ?? '', resolution: resolution, serverRegion: serverRegion, shouldShowMore: this.state.showMoreStats, transport: transport, videoSsrc: this.props._videoSsrc }));
    }
    _getConnectionStatus() {
        let tipKey;
        let colorClass;
        // let connectionStrength: "lost" | "inactive" | "good" | "nonoptimal" | "poor";
        const { _isConnectionStatusInactive, _isConnectionStatusInterrupted } = this.props;
        switch (true) {
            case _isConnectionStatusInterrupted:
                tipKey = 'connectionindicator.quality.lost';
                colorClass = "status-low";
                // tipKey = 'lost';
                // connectionStrength = 'lost';
                break;
            case _isConnectionStatusInactive:
                tipKey = 'connectionindicator.quality.inactive';
                colorClass = "status-low";
                // connectionStrength = 'inactive';
                break;
            default: {
                const { percent } = this.state.stats;
                if (typeof percent === 'undefined') {
                    // If percentage is undefined then there are no stats available
                    // yet, likely because only a local connection has been
                    // established so far. Assume a strong connection to start.
                    tipKey = 'connectionindicator.quality.good';
                    colorClass = "status-high";
                    // connectionStrength = 'good';
                }
                else {
                    const config = this._getDisplayConfiguration(percent);
                    tipKey = config.tip;
                    colorClass = config.colorClass || "status-high";
                    // connectionStrength = config.tip.split(".").at(-1) as any;
                }
            }
        }
        return { tipKey: this.props.t(tipKey), colorClass };
    }
}
export default translate(connect(_mapStateToProps, _mapDispatchToProps)(IISightConnectionIndicatorContent));
